// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.confirm-text[data-v-20db3b5e] {\n  font-size: 14px;\n  color: #333333;\n  margin: 10px 0 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
